import { useCallback, useEffect, useState } from "react";
import useMyMontepioContext from "../../../components/Context/useMyMontepioContext";
import { MGButton } from "../../../designSystem/components/MGButton";
import { MGDatePicker } from "../../../designSystem/components/MGDatePicker";
import { MGInputRadioButton } from "../../../designSystem/components/MGInputRadioButton";
import { MGLabel } from "../../../designSystem/components/MGLabel";
import { MGMicrotext } from "../../../designSystem/components/MGMicrotext";
import { MGSubtitle } from "../../../designSystem/components/MGSubtitle";
import { MGText } from "../../../designSystem/components/MGText";
import styles from "../Health.module.css";
import { TFormHealth } from "..";
import { genderOptions, TOptionGender } from "./types";
import { THealthFormContent } from "../api/types";
import { BackgroundForm } from "../../../components/BackgroundForm";

type TFormStepProps = {
  formHealth: TFormHealth;
  content: THealthFormContent;
  onContinue: (formHealth: TFormHealth) => void;
};

export const FormStep = ({ formHealth, content, onContinue }: TFormStepProps) => {
  const { isMobileAuth } = useMyMontepioContext();

  const [selectedGender, setSelectedGender] = useState<TOptionGender>();
  const [birthDate, setBirthDate] = useState<Date>();

  useEffect(() => {
    if (!!formHealth.dateOfBirth) {
      setBirthDate(new Date(formHealth.dateOfBirth));
    }

    if (!!formHealth.gender) {
      setSelectedGender(genderOptions.find((gender) => gender.value === formHealth.gender));
    }
  }, [formHealth.dateOfBirth, formHealth.gender]);

  const onDone = useCallback(() => {
    onContinue({ ...formHealth, moduleType: undefined, gender: selectedGender?.value });
  }, [onContinue, formHealth, selectedGender?.value]);

  return (
    <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
      <MGLabel style={{ marginTop: 8, marginBottom: 32 }} labelStyleDefinition={"80-03"}>
        {"Resumo simples da página."}
      </MGLabel>

      <BackgroundForm>
        <MGSubtitle style={{ marginBottom: 32 }} subtitleStyleDefinition={"200-06"}>
          {"Dados pessoais"}
        </MGSubtitle>

        <MGText style={{ marginBottom: 24 }} textStyleDefinition={"body-200-05"}>
          {"Género"}
        </MGText>

        <div className={styles.radioList}>
          {genderOptions
            .filter((gender) => gender.value !== "OTHER")
            .map((option) => (
              <div key={option.value} className={styles.radioOption}>
                <MGInputRadioButton
                  id={`gender-${option.value}`}
                  value={option.value}
                  checked={selectedGender?.value === option.value}
                  onChange={() => setSelectedGender(option)}
                />
                <MGMicrotext
                  key={option.value}
                  tagName="label"
                  htmlFor={`gender-${option.value}`}
                  microtextStyleDefinition={
                    selectedGender?.value === option.value ? "microcopy-100-05" : "microcopy-100-03"
                  }>
                  {option.name}
                </MGMicrotext>
              </div>
            ))}
        </div>

        <MGDatePicker labelText="Data de nascimento" value={birthDate} readOnly />
      </BackgroundForm>

      <div style={isMobileAuth ? { height: 32 } : undefined} />

      <MGButton
        disabled={!selectedGender || !birthDate}
        fullWidth={isMobileAuth}
        className={`${styles.buttonFooter} ${isMobileAuth ? styles.buttonFooterFixed : ""}`}
        onClick={onDone}>
        {"Continuar"}
      </MGButton>
    </div>
  );
};
